define('shared/util/dom/form/getFields',['shared/util/registers/ActionProvider', 'shared/lib/Emitter', 'shared/lib/RSVP'], 
function (ActionProvider, Emitter, RSVP) {
    var SELECTOR = 'input, select, textarea, div.functional a, button[type=submit]';
    
    return function getFields( $form ) {
        return ActionProvider.instance.get($form.attr('id'))
            .then(function(registered){
                var ret = {};
                Emitter(ret);

                var $btn = $form.find(SELECTOR).filter(':visible');
                var submitAction = registered && registered.actions['submit'];

                if ( submitAction ) {
                    if ( submitAction.triggers.length > 0 ) {
                        $btn = $btn.add( submitAction.triggers );
                    }
                    submitAction.triggers.on('add', function( triggers ){
                        $btn = $btn.add( triggers );
                        ret.emit('add',$btn);
                    });
                }

                ret.$btn = $btn;

                return RSVP.resolve( ret );
            });
    };
});
